import React, { FC } from 'react';
import { Fab, SpeedDialIcon } from '@mui/material';
import { useStyles } from '../styles';
import { useHistory } from 'react-router-dom';

interface LinkOnlyIconProps {
  path: string;
}

export const LinkOnlyIcon: FC<LinkOnlyIconProps> = ({ path }) => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <Fab
      color="primary"
      className={classes.speedDial}
      onClick={() => history.push(path)}
    >
      <SpeedDialIcon />
    </Fab>
  );
};
